"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reactQuery = require("react-query");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _serviceClients = require("@cimpress-technology/service-clients");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useSku = function useSku(sku, getAccessToken) {
  var client = new _serviceClients.BaseClient(getAccessToken);
  var scenesRequest = {
    ReferenceId: sku,
    Tenant: null
  };

  var getSku = function getSku() {
    return client.fetchWithAuth({
      endpointUrl: "https://introduction.products.cimpress.io/v3/mcpSkus/".concat(sku)
    }).then(function (skuRes) {
      return client.fetchWithAuth({
        endpointUrl: "https://scenes.documents.cimpress.io/v2/query?inputJson=".concat(JSON.stringify(scenesRequest))
      }).then(function (sceneRes) {
        var sceneUri = (0, _lodash["default"])(sceneRes, 'Results.[0].SceneUri');

        if (sceneUri) {
          sceneUri = "https://rendering.documents.cimpress.io/v1/preview?width=250&imageuris=https://catalog.products.cimpress.io/images/DefaultDecoration.png&scene=".concat(sceneUri);
        }

        return _objectSpread({}, skuRes, {
          scene: sceneUri
        });
      });
    });
  };

  return (0, _reactQuery.useQuery)(['sku', {
    sku: sku
  }], getSku, {
    staleTime: 99999999
  });
};

var _default = useSku;
exports["default"] = _default;